module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"back":"Zurück","receipt":"Beleg","filledStock":"Vollgut","empties":"Leergut","transactions":"Transaktionen","eanWasNotFound":"EAN nicht gefunden."},"en":{"back":"Back","receipt":"Receipt","filledStock":"Filled Stock","empties":"Empties","transactions":"Transactions","eanWasNotFound":"EAN was not found."}}')
  delete Component.options._Ctor
}
